export interface Video {
  id: string;
  title: string;
  type: "movie" | "tv" | "variety";
  typeLabel: string;
  year: number;
  region: string;
  rating: number;
  views: number;
  poster: string;
  backdrop?: string;
  summary: string;
  genres: string[];
  duration?: string;
  episodeCount?: number;
  featured?: boolean;
}

export const videos: Video[] = [
  {
    id: "interstellar-drift",
    title: "星际孤航",
    type: "movie",
    typeLabel: "电影",
    year: 2024,
    region: "美国",
    rating: 8.7,
    views: 1560000,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20floating%20before%20a%20giant%20ringed%20planet%20deep%20blue%20nebula%20and%20glowing%20stars%20dramatic%20cinematic%20lighting%20high%20detail%20poster%20art&width=600&height=900&seq=p01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20sci-fi%20landscape%20a%20lone%20astronaut%20standing%20before%20a%20giant%20ringed%20planet%20deep%20blue%20nebula%20star%20field%20epic%20scale%20dramatic%20lighting%20high%20detail&width=1600&height=900&seq=b01&orientation=landscape",
    summary:
      "一艘失联的深空飞船在穿越星门后偏离航线，唯一的幸存者必须在有限的生命维持时间内，重新找回回家的方向。",
    genres: ["科幻", "冒险", "剧情"],
    duration: "2小时18分钟",
    featured: true,
  },
  {
    id: "midnight-manhunt",
    title: "暗夜追凶",
    type: "movie",
    typeLabel: "电影",
    year: 2023,
    region: "中国大陆",
    rating: 7.9,
    views: 980000,
    poster:
      "https://readdy.ai/api/search-image?query=moody%20crime%20thriller%20movie%20poster%20rainy%20neon%20city%20street%20at%20night%20a%20detective%20silhouette%20walking%20under%20cold%20blue%20light%20cinematic%20dramatic%20high%20detail%20poster%20art&width=600&height=900&seq=p02&orientation=portrait",
    summary:
      "连续发生的神秘案件让整座城市陷入恐慌，一位被停职的老刑警被重新召回，在雨夜中追寻一个越来越近的影子。",
    genres: ["悬疑", "犯罪", "惊悚"],
    duration: "1小时52分钟",
  },
  {
    id: "homeland-dream",
    title: "山河故梦",
    type: "movie",
    typeLabel: "电影",
    year: 2022,
    region: "中国大陆",
    rating: 8.4,
    views: 1120000,
    poster:
      "https://readdy.ai/api/search-image?query=epic%20historical%20drama%20movie%20poster%20vast%20misty%20mountain%20landscape%20ancient%20chinese%20architecture%20warm%20golden%20sunset%20atmospheric%20cinematic%20high%20detail%20poster%20art&width=600&height=900&seq=p03&orientation=portrait",
    summary:
      "三代人的命运在一座山城里交织，从动荡年代到重逢时刻，故土与梦想始终是心中最沉的一段牵挂。",
    genres: ["剧情", "历史", "家庭"],
    duration: "2小时06分钟",
  },
  {
    id: "machine-era",
    title: "机械纪元",
    type: "movie",
    typeLabel: "电影",
    year: 2024,
    region: "美国",
    rating: 8.2,
    views: 1340000,
    poster:
      "https://readdy.ai/api/search-image?query=futuristic%20action%20movie%20poster%20giant%20robot%20guardian%20standing%20in%20a%20ruined%20industrial%20city%20orange%20sparks%20and%20steel%20metallic%20cinematic%20dramatic%20lighting%20poster%20art&width=600&height=900&seq=p04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20futuristic%20scene%20giant%20robot%20overlooking%20a%20glowing%20industrial%20city%20at%20night%20orange%20sparks%20and%20metallic%20textures%20epic%20dramatic%20high%20detail&width=1600&height=900&seq=b02&orientation=landscape",
    summary:
      "在人类与机械共存的新纪元，一台被认为报废的守护机器人重新启动，它要做的第一件事是履行一个早已被遗忘的承诺。",
    genres: ["科幻", "动作", "冒险"],
    duration: "2小时24分钟",
    featured: true,
  },
  {
    id: "dream-shop",
    title: "梦境商店",
    type: "movie",
    typeLabel: "电影",
    year: 2022,
    region: "日本",
    rating: 8.5,
    views: 760000,
    poster:
      "https://readdy.ai/api/search-image?query=whimsical%20fantasy%20movie%20poster%20a%20cozy%20floating%20shop%20above%20clouds%20with%20glowing%20lanterns%20pastel%20twilight%20dreamy%20soft%20light%20cinematic%20high%20detail%20poster%20art&width=600&height=900&seq=p05&orientation=portrait",
    summary:
      "云层之上有一家只在深夜营业的小店，客人可以用一段回忆交换一个梦，直到某天一位女孩带来了再也换不回的记忆。",
    genres: ["奇幻", "温情", "动画"],
    duration: "1小时44分钟",
  },
  {
    id: "desert-train",
    title: "荒漠列车",
    type: "movie",
    typeLabel: "电影",
    year: 2023,
    region: "美国",
    rating: 7.8,
    views: 540000,
    poster:
      "https://readdy.ai/api/search-image?query=western%20drama%20movie%20poster%20a%20vintage%20steam%20train%20crossing%20a%20vast%20desert%20canyon%20under%20warm%20dusty%20sunset%20sky%20cinematic%20wide%20composition%20high%20detail%20poster%20art&width=600&height=900&seq=p06&orientation=portrait",
    summary:
      "一趟穿越荒漠的蒸汽列车载着各怀心事的乘客，当沙暴来临，所有人都必须在这条铁轨上做出选择。",
    genres: ["西部", "剧情", "冒险"],
    duration: "1小时58分钟",
  },
  {
    id: "changan-twelve",
    title: "长安十二辰",
    type: "tv",
    typeLabel: "电视剧",
    year: 2023,
    region: "中国大陆",
    rating: 9.0,
    views: 2100000,
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20drama%20poster%20grand%20traditional%20city%20at%20dusk%20with%20lanterns%20and%20red%20walls%20misty%20atmospheric%20cinematic%20high%20detail%20poster%20art&width=600&height=900&seq=p07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20ancient%20chinese%20imperial%20city%20at%20dusk%20glowing%20lanterns%20and%20red%20walls%20misty%20mountains%20atmospheric%20epic%20historical%20high%20detail&width=1600&height=900&seq=b03&orientation=landscape",
    summary:
      "长安城在十二个时辰内暗流涌动，一位出身低微的探案者在层层迷雾中抽丝剥茧，守护这座城池的安宁。",
    genres: ["古装", "悬疑", "历史"],
    episodeCount: 24,
    featured: true,
  },
  {
    id: "foggy-capital",
    title: "雾都疑云",
    type: "tv",
    typeLabel: "电视剧",
    year: 2022,
    region: "英国",
    rating: 8.6,
    views: 1450000,
    poster:
      "https://readdy.ai/api/search-image?query=british%20detective%20series%20poster%20foggy%20victorian%20london%20street%20with%20gas%20lamps%20and%20a%20lone%20figure%20in%20a%20long%20coat%20moody%20green%20gray%20cinematic%20poster%20art&width=600&height=900&seq=p08&orientation=portrait",
    summary:
      "浓雾笼罩的城市里，一桩尘封多年的旧案重新浮出水面，两位性格迥异的探员被迫联手揭开真相。",
    genres: ["悬疑", "犯罪", "剧情"],
    episodeCount: 12,
  },
  {
    id: "city-warmth",
    title: "都市烟火",
    type: "tv",
    typeLabel: "电视剧",
    year: 2024,
    region: "中国大陆",
    rating: 8.2,
    views: 1780000,
    poster:
      "https://readdy.ai/api/search-image?query=modern%20urban%20family%20drama%20poster%20city%20skyline%20at%20warm%20evening%20with%20cozy%20lit%20windows%20soft%20blue%20and%20orange%20tones%20cinematic%20heartfelt%20poster%20art&width=600&height=900&seq=p09&orientation=portrait",
    summary:
      "一栋老楼里的几户人家，在都市的忙碌中彼此扶持，用一日三餐与琐碎日常，熬出最踏实的生活味道。",
    genres: ["都市", "家庭", "剧情"],
    episodeCount: 30,
  },
  {
    id: "healers-heart",
    title: "医者仁心",
    type: "tv",
    typeLabel: "电视剧",
    year: 2021,
    region: "中国大陆",
    rating: 8.9,
    views: 1650000,
    poster:
      "https://readdy.ai/api/search-image?query=medical%20drama%20series%20poster%20hospital%20corridor%20with%20soft%20daylight%20and%20a%20focused%20doctor%20in%20scrubs%20clean%20calm%20cinematic%20high%20detail%20poster%20art&width=600&height=900&seq=p10&orientation=portrait",
    summary:
      "急诊室里没有彩排，每一次抢救都是与时间的赛跑。一群平凡的医者，用专业与温柔撑起无数家庭的希望。",
    genres: ["医疗", "剧情", "职业"],
    episodeCount: 20,
  },
  {
    id: "throne-summit",
    title: "权谋之巅",
    type: "tv",
    typeLabel: "电视剧",
    year: 2024,
    region: "美国",
    rating: 8.8,
    views: 1980000,
    poster:
      "https://readdy.ai/api/search-image?query=epic%20political%20drama%20poster%20throne%20room%20with%20dark%20stone%20and%20golden%20light%20a%20regal%20silhouette%20atmospheric%20tense%20cinematic%20high%20detail%20poster%20art&width=600&height=900&seq=p11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20grand%20dark%20throne%20hall%20with%20towering%20stone%20columns%20and%20golden%20shafts%20of%20light%20epic%20tense%20political%20atmosphere%20high%20detail&width=1600&height=900&seq=b04&orientation=landscape",
    summary:
      "一张王座，四方势力。当忠诚与野心在同一屋檐下较量，每一步都可能成为改写格局的关键一子。",
    genres: ["历史", "权谋", "剧情"],
    episodeCount: 18,
    featured: true,
  },
  {
    id: "deep-sea-visitor",
    title: "深海来客",
    type: "tv",
    typeLabel: "电视剧",
    year: 2023,
    region: "美国",
    rating: 8.0,
    views: 870000,
    poster:
      "https://readdy.ai/api/search-image?query=deep%20sea%20sci-fi%20thriller%20poster%20dark%20ocean%20depths%20with%20a%20mysterious%20glowing%20creature%20and%20a%20submarine%20beam%20eerie%20blue%20cinematic%20poster%20art&width=600&height=900&seq=p12&orientation=portrait",
    summary:
      "一支深潜科考队在海底发现了一段不属于任何已知文明的信号，随着下潜深度增加，队员们开始看见不该看见的东西。",
    genres: ["科幻", "惊悚", "悬疑"],
    episodeCount: 10,
  },
  {
    id: "star-night",
    title: "星动之夜",
    type: "variety",
    typeLabel: "综艺",
    year: 2024,
    region: "中国大陆",
    rating: 8.5,
    views: 2600000,
    poster:
      "https://readdy.ai/api/search-image?query=music%20variety%20show%20poster%20bright%20concert%20stage%20with%20spotlights%20and%20confetti%20energetic%20colorful%20crowd%20lively%20cinematic%20high%20detail%20poster%20art&width=600&height=900&seq=p13&orientation=portrait",
    summary:
      "集结不同世代歌手的舞台竞演，每一期都有全新的改编与合作，让经典旋律在聚光灯下焕发新的生命力。",
    genres: ["音乐", "真人秀", "竞演"],
    episodeCount: 16,
  },
  {
    id: "wilderness-survival",
    title: "荒野求生记",
    type: "variety",
    typeLabel: "综艺",
    year: 2023,
    region: "中国大陆",
    rating: 8.3,
    views: 1420000,
    poster:
      "https://readdy.ai/api/search-image?query=outdoor%20adventure%20reality%20show%20poster%20rugged%20mountain%20wilderness%20with%20a%20campfire%20and%20climbing%20gear%20dramatic%20sunrise%20cinematic%20high%20detail%20poster%20art&width=600&height=900&seq=p14&orientation=portrait",
    summary:
      "嘉宾们被投放到无人荒野，只带最基础的装备，用三天时间完成生存挑战，真实记录每一次抉择与互助。",
    genres: ["户外", "竞技", "纪实"],
    episodeCount: 14,
  },
  {
    id: "gourmet-odyssey",
    title: "美食奇遇记",
    type: "variety",
    typeLabel: "综艺",
    year: 2024,
    region: "中国大陆",
    rating: 8.7,
    views: 1890000,
    poster:
      "https://readdy.ai/api/search-image?query=food%20travel%20show%20poster%20rustic%20wooden%20table%20with%20steaming%20regional%20dishes%20warm%20cozy%20ambient%20light%20appetizing%20cinematic%20high%20detail%20poster%20art&width=600&height=900&seq=p15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20rustic%20food%20market%20street%20with%20steaming%20stalls%20warm%20cozy%20evening%20light%20colorful%20regional%20dishes%20atmospheric%20high%20detail&width=1600&height=900&seq=b05&orientation=landscape",
    summary:
      "跟随主持人走进不同城市的街头巷尾，从一碗热汤到一桌家宴，用食物讲述一座城市最深处的记忆。",
    genres: ["美食", "旅行", "生活"],
    episodeCount: 12,
    featured: true,
  },
  {
    id: "comedy-league",
    title: "喜剧大联盟",
    type: "variety",
    typeLabel: "综艺",
    year: 2024,
    region: "中国大陆",
    rating: 7.9,
    views: 1350000,
    poster:
      "https://readdy.ai/api/search-image?query=comedy%20variety%20show%20poster%20colorful%20playful%20stage%20with%20balloons%20and%20bright%20lights%20joyful%20party%20atmosphere%20fun%20cinematic%20poster%20art&width=600&height=900&seq=p16&orientation=portrait",
    summary:
      "来自各地的喜剧人同台竞技，用段子、短剧与即兴表演展开比拼，只为把最简单的快乐送到观众心里。",
    genres: ["喜剧", "综艺", "竞演"],
    episodeCount: 20,
  },
  {
    id: "mind-duel",
    title: "脑力对决",
    type: "variety",
    typeLabel: "综艺",
    year: 2022,
    region: "韩国",
    rating: 8.4,
    views: 1100000,
    poster:
      "https://readdy.ai/api/search-image?query=quiz%20competition%20show%20poster%20sleek%20futuristic%20studio%20with%20glowing%20puzzle%20patterns%20and%20dramatic%20spotlights%20intense%20cinematic%20high%20detail%20poster%20art&width=600&height=900&seq=p17&orientation=portrait",
    summary:
      "高智商玩家齐聚一堂，在逻辑推理与心理博弈的赛场上角逐，层层设局、步步为营，直到最后的反转揭晓。",
    genres: ["竞技", "益智", "推理"],
    episodeCount: 15,
  },
  {
    id: "live-music-room",
    title: "音乐现场",
    type: "variety",
    typeLabel: "综艺",
    year: 2024,
    region: "中国大陆",
    rating: 8.1,
    views: 960000,
    poster:
      "https://readdy.ai/api/search-image?query=live%20music%20talk%20show%20poster%20intimate%20stage%20with%20acoustic%20instruments%20and%20warm%20spotlights%20soft%20purple%20orange%20ambiance%20cozy%20cinematic%20poster%20art&width=600&height=900&seq=p18&orientation=portrait",
    summary:
      "一间小小的演出现场，歌手与乐手围坐弹唱，聊创作、聊生活，用最松弛的状态把一首歌讲给你听。",
    genres: ["音乐", "访谈", "现场"],
    episodeCount: 10,
  },
];

export const categoryMeta = [
  {
    type: "movie",
    label: "电影",
    desc: "精选院线与独立佳片，类型丰富、画质清晰，随时开启一段光影旅程。",
    icon: "ri-film-line",
  },
  {
    type: "tv",
    label: "电视剧",
    desc: "古装、悬疑、都市、职场应有尽有，多集连播，追剧不停歇。",
    icon: "ri-live-line",
  },
  {
    type: "variety",
    label: "综艺",
    desc: "音乐、竞技、美食、户外，轻松下饭，快乐随时在线。",
    icon: "ri-mic-line",
  },
];

export const regions = ["全部", "中国大陆", "美国", "英国", "日本", "韩国"];
export const decades = ["全部", "2024", "2023", "2022", "2021"];
export const ratingRanges = ["全部", "9分以上", "8分以上", "7分以上"];